/** styles/tokens.css 머리 주석의 규약과 같은 값. 한쪽을 고치면 다른 쪽도 고친다. */
export const BREAKPOINTS = { sm: 480, md: 768, lg: 1024, xl: 1280 } as const

export type BreakpointName = keyof typeof BREAKPOINTS

const ASCENDING = [0, BREAKPOINTS.sm, BREAKPOINTS.md, BREAKPOINTS.lg, BREAKPOINTS.xl]

/**
 * 폭을 그 폭이 든 구간의 시작값으로 내린다(500 → 480, 1439 → 1280).
 *
 * 배치 판단은 "어느 구간에 있나"만 보므로, 창을 1px 씩 끌어도 이 값은 그대로다.
 * 화면이 실제 폭 대신 이 값을 구독하면 구간을 넘을 때만 다시 그린다.
 * 어떤 판단에 넣어도 실제 폭을 넣은 것과 결과가 같다 — 기준선이 곧 구간의 경계다.
 */
export function breakpointWidth(width: number): number {
  let snapped = 0
  for (const edge of ASCENDING) {
    if (width >= edge) snapped = edge
  }
  return snapped
}
